import { render, staticRenderFns } from "./TableHomeworkStreamDataList.vue?vue&type=template&id=5bdaaaea&scoped=true"
import script from "./TableHomeworkStreamDataList.vue?vue&type=script&lang=js"
export * from "./TableHomeworkStreamDataList.vue?vue&type=script&lang=js"
import style0 from "./TableHomeworkStreamDataList.vue?vue&type=style&index=0&id=5bdaaaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdaaaea",
  null
  
)

export default component.exports